<template>
    <el-drawer
        title="创建厂牌"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                v-loading="dataLoading"
            >
                <el-form-item prop="name" label="厂牌名称:">
                    <el-input
                        v-model="formData.name"
                        placeholder="请输入厂牌名称"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="city" label="所在城市">
                    <el-cascader
                        v-model="formData.city"
                        :options="cityList"
                        filterable
                        :props="{label:'name',children:'cityList',value:'code',emitPath:false}"
                        size="medium"
                        style="width:100%"
                        ref="cityCascader">
                    </el-cascader>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {fetchAllCity} from '@/assets/js/commonApi'

const defaultFormData = {
    name: "",
    city:10,
    // password:'Thshowstart123'
}
export default {
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                name: [{ required: true, message: "请输入厂牌名称" }],
                city:[{required: true, message: '请选择所在城市'}],
            },
            cityList:[],//所有省份城市集合
        };
    },
    mounted(){
        this.getCityList()
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show() {
            this.drawerShow = true;
        },
        //获取所有城市
        async getCityList(){
            const res = await fetchAllCity({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.cityList = result;
            }
        },
        //表单提交
        submitForm() {
            // console.log(this.formData)
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _url = "/brand/save";
                    this.btnLoading = true;

                    this.$request({
                        url: _url,
                        data: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate',result);
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
